<template>
  <div id="home">
    <div
      class="separador text-center py-5 z100"
      data-aos="fade-up"
      data-aos-delay="600"
    >
      <p class="fXG blanco">Tickets Registrados</p>
    </div>

    <div class="container-fluid">
      <!-- <div class="row pb-5">
        <div class="col-12  fG azuloscuro">Semana 1</div>
      </div>-->

      <div class="row">
        <div class="col-6 py-5">
          <router-link
            class="btn btn-danger pointer"
            to="/administrador/usuarios"
            >Descarga de usuarios &raquo;
          </router-link>
        </div>
        <div class="col-6 py-5 text-right">
          <div class="z100">
            <button class="btnaction px-5 bold z100" @click="logout()">
              Cerrar sesión
            </button>
          </div>
        </div>
      </div>

      <b-tabs content-class="mt-3 row">
        <!-- <b-tab title="Participaciones por validar"> -->
        <b-tab title="Participaciones">
          <div class>
            <div class="col-12 blanco pt-5 pb-3">
              <span class="fG">Participaciones</span>
              (Total: {{ tickets.length }})
            </div>

            <div class="col-12">
              <download-excel
                :data="this.tickets"
                name="Kelloteria - Tickets.xls"
                :fields="this.excelcolumns"
              >
                <button class="btn btn-danger">Exportar Participaciones</button>
              </download-excel>
            </div>
            <div class="col-12">
              <v-client-table
                class="blanco vclient"
                :columns="columns"
                v-model="tickets"
                :options="options"
              >
                <a
                  slot="uri"
                  slot-scope="props"
                  target="_blank"
                  :href="props.row.uri"
                  class="glyphicon glyphicon-eye-open"
                  >Ver</a
                >

                <div slot="child_row" slot-scope="props" class="">
                  <div class="row pb-4">
                    <div class="col-12 fG text-left"><b>Ticket</b></div>
                    <div class="col-md-6 text-left">
                      <a target="_blank" :href="props.row.img_ticket_url">
                        <img
                          :src="props.row.img_ticket_url"
                          alt="imagen ticket"
                          width="100"
                        />
                      </a>

                      <div class="px-3 py-3">
                        <p>Selecciona si el ticket es GANADOR CINEPOLIS del día:</p>
                        <p>
                          <select
                            class="form-control"
                            name=""
                            id=""
                            v-model="props.row.ganador"
                          >
                            <option value="" hidden>Selecciona...</option>
                            <option
                              value="1"
                              :selected="props.row.ganador == '1'"
                            >
                              Es ganador
                            </option>
                            <option
                              value="0"
                              :selected="props.row.ganador == '0'"
                            >
                              No es ganador
                            </option>
                          </select>
                        </p>

                        <p>
                          <button
                            class="btnaction2"
                            @click="
                              changeGanadorTicket(
                                props.row.id,
                                props.row.ganador,
                                props.row.telefono
                              )
                            "
                          >
                            Actualizar ticket
                          </button>
                        </p>
                      </div>


                      <!-- <div class="px-3 py-3">
                        <p>Ingresa el monto de productos participantes manualmente:</p>
                        <p>

                          <input type="text" class="form-control" v-model="props.row.monto_productos_participantes" placeholder="Ingresa el monto en productos participantes manualmente" >
                        </p>

                        <p>
                          <button
                            class="btnaction2"
                            @click="
                              changeMontoTicket(
                                props.row.id,
                                props.row.monto_productos_participantes,
                                props.row.telefono
                              )
                            "
                          >
                            Actualizar ticket
                          </button>
                        </p>
                      </div> -->

                      <div class="px-3 py-3">
                        <p>Selecciona un STATUS de validación:</p>
                        <p>
                          <select
                            class="form-control"
                            name=""
                            id=""
                            v-model="props.row.validacion"
                            @change="
                              seleccionaStatusChange(props.row.validacion)
                            "
                          >
                            <option value="" hidden>
                              Selecciona un status
                            </option>
                            <option
                              value="valido"
                              :selected="props.row.validacion == 'valido'"
                            >
                              valido
                            </option>
                            <option
                              value="invalido"
                              :selected="props.row.validacion == 'invalido'"
                            >
                              invalido
                            </option>
                          </select>
                        </p>

                        <p>
                          <button
                            class="btnaction2"
                            @click="
                              changeStatusTicket(
                                props.row.id,
                                props.row.validacion,
                                props.row.telefono
                              )
                            "
                          >
                            Actualizar ticket
                          </button>
                        </p>
                      </div>
                    </div>
                  </div>

                  <div v-if="props.row.validacion == 'invalido'">
                    <div class="col-md-6 text-left">
                      <div class="px-3">
                        <p>Selecciona un SUBSTATUS:</p>
                        <p>
                          <select
                            class="form-control"
                            name=""
                            id=""
                            v-model="props.row.substatus"
                          >
                            <option value="" hidden>
                              Selecciona un substatus
                            </option>
                            <option
                              value="ticket duplicado"
                              :selected="
                                props.row.substatus == 'ticket duplicado'
                              "
                            >
                              Ticket duplicado
                            </option>
                            <option
                              value="ticket ilegible"
                              :selected="
                                props.row.substatus == 'ticket ilegible'
                              "
                            >
                              Ticket ilegible
                            </option>
                            <option
                              value="ticket incorrecto"
                              :selected="
                                props.row.substatus == 'ticket incorrecto'
                              "
                            >
                              Ticket incorrecto
                            </option>

                            <option
                              value="no es ticket"
                              :selected="props.row.substatus == 'no es ticket'"
                            >
                              No es ticket
                            </option>

                            <option
                              value="fuera de vigencia"
                              :selected="
                                props.row.substatus == 'fuera de vigencia'
                              "
                            >
                              Fuera de vigencia
                            </option>

                            <option
                              value="no cumple monto minimo"
                              :selected="
                                props.row.substatus == 'no cumple monto minimo'
                              "
                            >
                              No cumple monto mínimo
                            </option>

                            
                            <option
                              value="producto no participante"
                              :selected="
                                props.row.substatus ==
                                'producto no participante'
                              "
                            >
                              Producto no participante
                            </option>

                            <option
                              value="ticket duplicado"
                              :selected="
                                props.row.substatus == 'ticket duplicado'
                              "
                            >
                              Ticket duplicado
                            </option>

                            <option
                              value="otro"
                              :selected="props.row.substatus == 'otro'"
                            >
                              otro
                            </option>
                          </select>
                        </p>

                        <p>
                          <button
                            class="btnaction2"
                            @click="
                              changeSubStatusTicket(
                                props.row.id,
                                props.row.substatus,
                                props.row.telefono
                              )
                            "
                          >
                            Actualizar ticket
                          </button>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    class="row"
                    v-if="
                      props.row.no_membresia_plus != '' &&
                      props.row.no_membresia_plus != undefined
                    "
                  >
                    <div class="col-12 fG"><b>Membresía plus</b></div>
                    <div class="col-md-6">
                      <a target="_blank" :href="props.row.img_membresia_frente">
                        <img
                          :src="props.row.img_membresia_frente"
                          alt="imagen membresia frente"
                          class="pr-3"
                          width="100"
                        />
                        <img
                          :src="props.row.img_membresia_reves"
                          alt="imagen membresia reves"
                          width="100"
                        />
                      </a>

                      <div class="px-3">
                        <p>¿La membresía es válida?:</p>
                        <p>
                          <select
                            class="form-control"
                            name=""
                            id=""
                            v-model="props.row.status_membresia"
                          >
                            <option value="por validar" hidden>
                              Selecciona un status
                            </option>
                            <option
                              value="valida"
                              :selected="props.row.status == 'valida'"
                            >
                              Válida
                            </option>
                            <option
                              value="imagen incorrecta"
                              :selected="
                                props.row.status == 'imagen incorrecta'
                              "
                            >
                              Imagen incorrecta
                            </option>

                            <option
                              value="NO es membresia plus"
                              :selected="
                                props.row.status == 'No es membresia plus'
                              "
                            >
                              No es membresia plus
                            </option>

                            <option
                              value="numero de membresia no coincide con la foto"
                              :selected="
                                props.row.status ==
                                'numero de membresia no coincide con la foto'
                              "
                            >
                              Número de membresía no coincide con la foto
                            </option>

                            <option
                              value="otro"
                              :selected="props.row.status == 'otro'"
                            >
                              Otro
                            </option>
                          </select>
                        </p>

                        <p>
                          <button
                            class="btnicono"
                            @click="
                              changeStatusMembresia(
                                props.row.id,
                                props.row.user_id,
                                props.row.status_membresia,
                                props.row.email
                              )
                            "
                          >
                            <span class="blanco">Actualizar membresía</span>
                          </button>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  slot="name"
                  slot-scope="{
                    row,
                    update,
                    setEditing,
                    isEditing,
                    revertValue,
                  }"
                >
                  <span @click="setEditing(true)" v-if="!isEditing()">
                    <a>{{ row.name }}</a>
                  </span>
                  <span v-else>
                    <input type="text" v-model="row.name" />
                    <button
                      type="button"
                      class="btn btn-info btn-xs"
                      @click="
                        update(row.name);
                        setEditing(false);
                      "
                    >
                      Submit
                    </button>
                    <button
                      type="button"
                      class="btn btn-default btn-xs"
                      @click="
                        revertValue();
                        setEditing(false);
                      "
                    >
                      Cancel
                    </button>
                  </span>
                </div>
              </v-client-table>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>

    <Footer></Footer>
    <!-- <Glyphicons></Glyphicons> -->
  </div>
</template>


<script>
const SECONDS_PER_DAY = 86400;
const HOURS_PER_DAY = 24;
const SEMANA_INICIAL = 27;
import Footer from "@/components/Footer";
// import Glyphicons from "@/views/Glyphicons";
import AOS from "aos";
import swal from "sweetalert2";

import * as moment from "moment";
import Vue from "vue";

import { ServerTable, ClientTable, Event } from "vue-tables-2";
Vue.use(ClientTable);

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

export default {
  components: {
    Footer,
    // Glyphicons,
  },
  data() {
    return {
      columns: [
        "id",
        "usuario_id",
        "validacion",
        "substatus",
        // "num_correctas",
        "ganador",
        "codigo_cinepolis",
        // "monto_productos_participantes",
        "no_ticket",
        
        // "nombre_completo",
        "telefono",
        // "respuesta_primer_pregunta",
        // "correcta_primer_pregunta",
        // "fecha_primer_respuesta",
        // "respuesta_segunda_pregunta",
        // "correcta_segunda_pregunta",
        // "fecha_segunda_respuesta",
        // "respuesta_tercer_pregunta",
        // "correcta_tercer_pregunta",
        // "fecha_tercer_respuesta",
        
        "timestamp",
        //"invoice_duplicado",
        // "validacion_fecha",
        // "validacion_monto",

      ],
      excelcolumns: {
        "Ticket ID": "id",
        Status: "validacion",
        Substatus: "substatus",
        Validacion: "validacion",
        "Ganador Cinépolis": "ganador",
        "Monto Productos Participantes": "monto_productos_participantes",
        // "ID Boleto": "boleto",
        Telefono: "telefono",
        "Fecha de registro": "timestamp",
      },
      data: null,
      options: {
        perPage: 100,
        headings: {
        usuarios_id: "Usuario ID",
          id: "Ticket UID",
          week: "Semana",
          no_ticket: "No. Ticket",
          invoice_duplicado: "No. Ticket Duplicado",
          validacion_prods_participantes: "Validación Productos Participantes",
          tipo_juego: "Tipo Juego",
          no_membresia_plus: "No. membresía plus",
          status_membresia: "Status membresía",
          "ticket_ocr.total": "Ticket total",
          "ticket_ocr.date": "Fecha en Ticket",
          nombre: "Nombre",
          apellido: "Apellido",
          apellido2: "Segundo Apellido",
          email: "Email",
          puntos: "Puntos x juego",
          puntos_convertidos: "Puntos",
          puntos_acumulados: "Puntos agregados por ticket",
          validacion: "Status Ticket",
          substatus: "Substatus Ticket",
          tipo_cupon: "Tipo Cupón",
          codigo_dulceria: "Cupón Dulcería",
          codigo_oxxo: "Cupón OXXO",
          mnms: "Ticket con M&Ms",
          tiempo: "Tiempo Participación",
          segundos: "Segundos Participación",
          intento_trampa:
            "Posible Trampa (si fecha, campo válido: Segundos Servidor)",
          // started_on: "Fecha Ini User",
          // finished_on: "Fecha Fin User",
          // diferencia_segs_user: "Segundos User",
          created_on_server: "Fecha Registro (Servidor)",
          finished_on_server: "Fecha Fin de Participación (Servidor)",
          diferencia_segundos_servidor: "Segundos Servidor",
          timestamp: "Fecha de registro",
          ganador: "Ganador Boleto Cinépolis"
        },
        editableColumns: [],
        sortable: [],
      },
      columns_users: [
        "user_id",
        "nombre",
        "apellido",
        "apellido2",
        "email",
        "genero",
        "celular",
        "fecha_nacimiento",
        "edad",
        "suma_puntos",
        "suma_time",
        "suma_time_txt",
        "num_tickets",
        "created_on",
        "dia_registro",
      ],
      data_users: null,
      options_users: {
        perPage: 100,
        headings: {
          user_id: "UID",
          nombre: "Nombre",
          apellido: "Apellido",
          apellido2: "Segundo Apellido",
          email: "Email",
          genero: "Genero",
          tel: "Tel",
          fecha_nacimiento: "Fec. Nac.",
          edad: "Edad",
          suma_puntos: "Suma Puntos",
          suma_time: "Suma Segundos",
          suma_time_txt: "Tiempo Total",
          num_tickets: "Número de Tickets",
          created_on: "Fecha de Registro",
          dia_registro: "Día de Registro",
        },
        editableColumns: [],
        sortable: ["edad", "suma_puntos", "suma_time", "num_tickets"],
      },
      tickets: [],
      tickets_procesados: [],
      users: {},
      users_array: [],
      users_auth: [],
      mostrar_monto: false,
      monto: 0,
      multiplicador: 1,
    };
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });
    this.init();
  },
  methods: {
    async init() {
      this.$store.dispatch("showLoader", true);
      await this.getUsers();
      await this.getTickets();
    },
    logout() {
      this.$store.dispatch("logoutReportes");
    },
    seleccionaStatusChange(status) {
      // this.monto = 0;
      // console.log(status);
      // if(status == "$40 en productos de la Familia Coca-Cola en tiendas OXXO"){
      //   this.mostrar_monto = true;
      // }else{
      //   this.mostrar_monto = false;
      // }
    },
    async getTickets() {
      console.log("getting tickets");

      let qData = {};

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "getParticipaciones.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data

            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              console.log("got tickets");
              this.tickets = res.participaciones;
              console.log(this.tickets);
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            console.log(error);
          }
        );
    },
    setUsersArray() {
      this.users_array = [];
      Object.keys(this.users).forEach((key) => {
        let obj = this.users[key];
        obj.user_id = key;
        obj.edad = moment().diff(obj.fecha_nacimiento, "years");
        //console.log(key, obj);
        this.users_array.push(obj);
      });
    },
    sumaScore(participaciones, cashi) {
      let score = 0;
      participaciones.forEach((participacion) => {
        score += participacion.score;
      });

      if (cashi === "Pago con CASHI") {
        score = score * 2;
      }

      return score;
    },
    sumaStatsUser(user_id, puntos, time) {
      if (puntos == undefined) puntos = 0;
      if (time == undefined) time = 0;

      let multiplicador = 1;

      // console.log(user_id);
      // console.log(this.users[user_id]);

      if (this.users[user_id] == undefined) return;

      if (this.users[user_id].suma_puntos == undefined)
        this.users[user_id].suma_puntos = 0;
      try {
        this.users[user_id].suma_puntos += parseInt(puntos) * multiplicador;
      } catch (err) {
        console.log(err);
      }

      if (this.users[user_id].suma_time == undefined)
        this.users[user_id].suma_time = 0;
      try {
        this.users[user_id].suma_time += parseInt(time);
        this.users[user_id].suma_time_txt = this.secondsToHms(
          this.users[user_id].suma_time
        );
      } catch (err) {
        console.log(err);
      }

      if (this.users[user_id].num_tickets == undefined)
        this.users[user_id].num_tickets = 0;
      try {
        this.users[user_id].num_tickets++;
      } catch (err) {
        console.log(err);
      }
    },
    calculaDiferenciaTiempos(started, finished) {
      try {
        //console.log({ started: started.seconds });
        //console.log({ finished: finished.seconds });
        if (started.seconds == null || finished.seconds == null) return "error";
        let d1 = moment.unix(started.seconds);
        //console.log({ d1: d1 });
        let d2 = moment.unix(finished.seconds);
        //console.log({ d2: d2 });
        return d2.diff(d1, "seconds");
      } catch (err) {
        return "error";
      }
    },
    async getUsers() {
      console.log("getting users");
    },
    secondsToHms(seconds) {
      const days = Math.floor(seconds / SECONDS_PER_DAY);
      const remainderSeconds = seconds % SECONDS_PER_DAY;
      const hms = new Date(remainderSeconds * 1000)
        .toISOString()
        .substring(11, 19);
      return hms.replace(/^(\d+)/, (h) =>
        `${Number(h) + days * HOURS_PER_DAY}`.padStart(2, "0")
      );
    },
    // procesaTickets(){
    //   this.tickets_procesados = []
    //   this.tickets.forEach(ticket => {

    //   })
    // },
    custom_sort(a, b) {
      return new Date(a.created_on.seconds) - new Date(b.created_on.seconds);
    },
    getNumSemana(fecha) {
      return parseInt(this.getSemana(fecha)) - SEMANA_INICIAL;
    },
    getSemana(fecha) {
      return moment(fecha).add(2, "days").week();
    },
    getFechaFormato(time) {
      return moment.unix(time).format("MMM D, Y HH:mm:ss");
    },
    async changeStatusTicket(id, value, telefono) {
      console.log({ changeStatus: id });
      console.log({ changeStatus: value });
      console.log({ changeStatus: telefono });

      this.$store.dispatch("showLoader", true);

      let qData = {
        id: id,
        status: value,
        telefono: telefono,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeStatusTicket.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              // this.tickets = res.participaciones;
              // console.log(this.tickets);

              swal.fire(
                "Bien",
                "Se ha actualizado el estatus del ticket.",
                "success"
              );

              this.getTickets();

              // for (var i = 0; i < this.tickets.length; i++) {
              //   if (this.tickets[i].id === id) {
              //     this.tickets[i].status = value;
              //   }
              // }
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            console.log(error);
          }
        );
    },

    async changeSubStatusTicket(id, value, telefono) {
      console.log({ changeSubtatus: id });
      console.log({ changeSubtatus: value });
      console.log({ changeSubtatus: telefono });

      this.$store.dispatch("showLoader", true);

      let qData = {
        id: id,
        status: value,
        telefono: telefono,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeSubStatusTicket.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              // this.tickets = res.participaciones;
              // console.log(this.tickets);

              swal.fire(
                "Bien",
                "Se ha actualizado el estatus del ticket.",
                "success"
              );

              this.getTickets();

              // for (var i = 0; i < this.tickets.length; i++) {
              //   if (this.tickets[i].id === id) {
              //     this.tickets[i].status = value;
              //   }
              // }
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            console.log(error);
          }
        );
    },

    async changeGanadorTicket(id, value, telefono) {
      console.log({ changeStatus: id });
      console.log({ changeStatus: value });
      console.log({ changeStatus: telefono });

      this.$store.dispatch("showLoader", true);

      let qData = {
        id: id,
        status: value,
        telefono: telefono,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeGanadorTicket.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              // this.tickets = res.participaciones;
              // console.log(this.tickets);

              swal.fire(
                "Bien",
                "Se ha actualizado el estatus del ticket.",
                "success"
              );

              // ENVÍA CUPÓN
              if(value == "1" && res.codigo_asignado != ''){
                try {


                  
                  await this.$http.post(
                    // "https://9277a0ba1939.ngrok-free.app/send-coupon", // reemplaza con tu endpoint real
                    "https://kelloteria.pautacreativa.mx/send-coupon", // reemplaza con tu endpoint real
                    {
                      phone: telefono,
                      coupon: res.codigo_asignado, // reemplaza con lógica dinámica si hace falta
                      secret: "mi_clave_super_secreta"
                    },
                    {
                      headers: {
                        "Content-Type": "application/json"
                      }
                    }
                  );
                  console.log("Cupón enviado exitosamente.");
                } catch (e) {
                  console.error("Error al enviar cupón:", e);
                }
              }

              this.getTickets();

              // for (var i = 0; i < this.tickets.length; i++) {
              //   if (this.tickets[i].id === id) {
              //     this.tickets[i].status = value;
              //   }
              // }
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            console.log(error);
          }
        );
    },

    async changeMontoTicket(id, value, telefono) {
      console.log({ changeStatus: id });
      console.log({ changeStatus: value });
      console.log({ changeStatus: telefono });

      this.$store.dispatch("showLoader", true);

      let qData = {
        id: id,
        status: value,
        telefono: telefono,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeMontoTicket.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              // this.tickets = res.participaciones;
              // console.log(this.tickets);

              swal.fire(
                "Bien",
                "Se ha actualizado el estatus del ticket.",
                "success"
              );

              this.getTickets();

              // for (var i = 0; i < this.tickets.length; i++) {
              //   if (this.tickets[i].id === id) {
              //     this.tickets[i].status = value;
              //   }
              // }
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            console.log(error);
          }
        );
    },

    async changeStatusMembresia(id, userId, value, email) {
      console.log({ changeStatus: id });
      console.log({ changeStatus: value });
      console.log({ changeStatus: email });

      this.$store.dispatch("showLoader", true);

      await this.$store.dispatch("changeStatusMembresiaValidacion", {
        status: value,
        ticket_id: id,
        user_id: userId,
      });

      swal.fire(
        "Bien",
        "Se ha actualizado el estatus de la membresía.",
        "success"
      );

      //this.getTickets();

      for (var i = 0; i < this.tickets.length; i++) {
        if (this.tickets[i].id === id) {
          this.tickets[i].status_membresia = value;
        }
      }
    },
  },
};
</script>

